import { PaginationProps } from 'antd/lib';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useGetUserSettingsQuery, useSaveUserSettingMutation } from '../../modules/user/api/user-api';
import { useBreakpoint } from './use-breakpoint';
import { useRestrictedQueryParam } from './use-restricted-query-param';
import { useSetSearchParamsValue } from './use-set-search-params-value';

export const usePagination = (total: number | undefined, settingName: string) => {
  const { data: userSettings } = useGetUserSettingsQuery();
  const [saveSetting] = useSaveUserSettingMutation();
  const [searchParams, setSearchParams] = useSearchParams();
  const screens = useBreakpoint();
  const setSearchParamsValue = useSetSearchParamsValue();

  const limitQueryParam = useRestrictedQueryParam(
    'limit',
    ['10', '30', '50'],
    userSettings && (userSettings[settingName] || '30'),
  );

  const limit = Number(limitQueryParam);

  const changePage = (page: number) => setSearchParamsValue('page', page);

  const pagination: PaginationProps = {
    pageSize: limit,
    total,
    pageSizeOptions: ['10', '30', '50'],
    defaultPageSize: 30,
    responsive: true,
    showSizeChanger: !!screens.sm,
    current: Number(searchParams.get('page')) || 1,
    onChange: changePage,
    onShowSizeChange: (current: number, size: number) => {
      setSearchParamsValue('limit', size);
      saveSetting({
        name: settingName,
        value: JSON.stringify(size),
      });
    },
  };

  useEffect(() => {
    if (pagination.current) {
      if (total && pagination.current * limit - limit >= total) {
        searchParams.set('page', JSON.stringify(pagination.current - 1));
        setSearchParams(searchParams);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, total]);

  return [limit, pagination] as const;
};
